import { render, staticRenderFns } from "./info-dsa.vue?vue&type=template&id=5fc38e16&scoped=true"
import script from "./info-dsa.vue?vue&type=script&lang=js"
export * from "./info-dsa.vue?vue&type=script&lang=js"
import style0 from "./info-dsa.vue?vue&type=style&index=0&id=5fc38e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc38e16",
  null
  
)

export default component.exports